var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5979 9.67064C14.8267 9.89947 14.8267 10.2704 14.5979 10.4992L10.6916 14.4055C10.4628 14.6343 10.0919 14.6343 9.86305 14.4055L5.9568 10.4992C5.72797 10.2704 5.72797 9.89947 5.9568 9.67064C6.18563 9.44182 6.55656 9.44182 6.78539 9.67064L10.2773 13.1625L13.7693 9.67064C13.9981 9.44182 14.3691 9.44182 14.5979 9.67064Z",
    fill: "#0E0E0F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.502 14.5332C10.4329 14.5619 10.3571 14.5777 10.2777 14.5777C10.354 14.5777 10.4303 14.5628 10.502 14.5332Z",
    fill: "#0E0E0F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.064516c5d5b797d64701d1a5ca50a723.svg";
export { ForwardRef as ReactComponent };